import { render, staticRenderFns } from "./loyalty-tier-card.vue?vue&type=template&id=606fdc40&scoped=true&shadowMode"
import script from "./loyalty-tier-card.ts?vue&type=script&lang=ts&shadowMode"
export * from "./loyalty-tier-card.ts?vue&type=script&lang=ts&shadowMode"
function injectStyles (context) {
  
  var style0 = require("./loyalty-tier-card.scss?vue&type=style&index=0&id=606fdc40&lang=scss&scoped=true&shadow=true&shadowMode")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "606fdc40",
  null
  ,true
)

component.options.__file = "loyalty-tier-card.vue"
export default component.exports